import React, { useRef, useState } from "react";
import { useSetState } from "ahooks";
import { Flex, message, Tag, Tooltip } from "antd";
import { SDrawerOrModal, SLowcodeList, STags } from "shj-components";
import { useAtom } from "jotai";
import dayjs from "dayjs";
import { getProdCateTree, getProductEnums, getProductManagementPage } from "@/services/product.ts";

import { SPUDataAtom } from "@/pages/combinationManage/components/store.js";
import { apiData2Table } from "@/utils/data.ts";
import { config } from './config.jsx'
import styles from "@/pages/productClass/components/ChooseSPUModal/index.module.less";

const ChooseSPUModal = (props) => {
  const { open, onClose, onReload } = props;
  const [SPUData, setSPUData] = useAtom(SPUDataAtom)
  const listRef = useRef();
  const [prodCateIds, setProdCateIds] = useState([])
  const [state, setState] = useSetState<any>({
    selectedRows: [],
  })

  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      getProductManagementPage({
        params: { pageId: current, pageSize },
        data: {
          ...query,
          prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_BASIC_ITEM'],
          // sourceType: 'CONSTRUCTION',
          queryShops: true,
          notIds: SPUData.dataSource?.map(item => item.productId),
          prodCateIds,
        }
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(err => {
        reject(err)
      })
    })
  }

  // 树节点事件
  const onChangeType = (node: any, info) => {
    const current = info?.[info.length - 1]
    if (current) {
      setProdCateIds([current.id])
      findAllChildsId(current)
    } else {
      setProdCateIds([])
    }
  }
  const findAllChildsId = (node: any) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        setProdCateIds(prevIds => [...prevIds, child.id])
        findAllChildsId(child)
      })
    }
  }

  const getOptions = async () => {
    const prodCateTree = await getProdCateTree({ productLibrary: "RETAIL_LIBRARY", querySpuRelation: true })
    const sourceTypeList = await getProductEnums('com.shj.saas.plus.product.enums.ProductSourceType')
    return Promise.resolve({ prodCateTree, sourceTypeList })
  }

  const onDelSelect = id => {
    const selectedRows = state.selectedRows.filter(item => item.id !== id)
    selectedRows?.length <= 0 && listRef.current?.clearSelectedRowKeys()
    setState({ selectedRows })
    listRef.current?.setSelectedRowKeys(selectedRows?.map(item => item.id))
  }

  const onFinish = () => {
    if (state.selectedRows.length <= 0) {
      message.error('至少选择一个SPU');
      return;
    } else {
      setSPUData((SPUData) => ({
        dataSource: [...SPUData.dataSource, ...state.selectedRows]?.map(item => {
          return {
            ...item,
            size: item.size || 1,
            startDate: dayjs(),
            selectType: item.selectType || 'ALL',
            productId: item.productId || item.id,
            productName: item.productName || item.prodName,
          }
        })
      }))
      onClose()
    }
  }

  const extension = {
    request: { fetchList, getOptions },
    events: { onChangeType },
    rowKey: 'id',
    scroll: { y: 'calc(100vh - 485px)' },
    rowSelection: {
      preserveSelectedRowKeys: true,
      selectedRows: state.selectedRows,
      onChange: (selectedRowKeys, selectedRows) => {
        setState({ selectedRows })
      },
    },
    customRender: {
      nameRender(v) {
        return <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
    }
  }

  return <>
    <SDrawerOrModal
      title={'添加SPU'}
      open={open}
      loading={false}
      width={900}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
      {state.selectedRows.length > 0 &&
          <div style={{
            paddingTop: 20,
            position: "sticky",
            bottom: 0,
            zIndex: 10,
            backgroundColor: '#fff',
            maxHeight: 160,
            overflow: 'auto',
            borderTop: '1px solid #eee',
          }}>
            <Flex gap="4px 0" wrap>
              已选择：
              {state.selectedRows?.map((item) => <Tag className={styles.tag} key={item.id} closable
                                                      onClose={() => onDelSelect(item.id)}>
                <Tooltip title={item.prodName}>
                  <div className={styles.tagContent}>{item.prodName}</div>
                </Tooltip>
              </Tag>)}
            </Flex>
          </div>}
    </SDrawerOrModal>
  </>
}

export default ChooseSPUModal